module.exports = __webpack_public_path__ + "static/media/1152410.9557a12d.svg";